import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';

import STATE from '../enums/state.js';

const selectors = {
  carouselWrapper: '[data-sliding-banner-carousel]',
  swiperWrapper: '[data-swiper-wrapper]',
  swiperSlide: '[data-swiper-slide]',
};

const classes = {
  swiperWrapper: 'swiper-wrapper',
  swiperPagination: '.swiper-pagination',
  swiperSlide: 'swiper-slide',
};

class SlidingBannerImage extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.slidingBannerCarousel = this.querySelector(
        '[data-sliding-banner-carousel]'
      );
      this.swiperWrapper = this.slidingBannerCarousel.querySelector(
        selectors.swiperWrapper
      );
      this.swiperSlide = [
        ...this.slidingBannerCarousel.querySelectorAll(selectors.swiperSlide),
      ];
      this.breakpoint = window.matchMedia('(min-width:1024px)');

      this.initCarousel();

      this.registerEventListeners();
    });
  }

  getSlideByIndex(index) {
    return this.slides[index];
  }

  setActiveSlide(slide) {
    if (this.breakpoint.matches === false) {
      return;
    }

    const activeSlide = slide;

    if (
      Number(activeSlide.dataset.slide) === 0 &&
      activeSlide.dataset.state === STATE.SLIDINGBANNER.OPEN
    ) {
      return;
    }

    switch (Number(activeSlide.dataset.slide)) {
      case 0:
        activeSlide.dataset.state =
          activeSlide.dataset.state === STATE.SLIDINGBANNER.CLOSED
            ? STATE.SLIDINGBANNER.OPEN
            : STATE.SLIDINGBANNER.CLOSED;

        if (activeSlide.dataset.state === STATE.SLIDINGBANNER.OPEN) {
          this.getSlideByIndex(1).dataset.state = STATE.SLIDINGBANNER.DEFAULT;
        } else {
          this.getSlideByIndex(1).style.transform = STATE.SLIDINGBANNER.OPEN;
        }

        return;

      case 1:
        activeSlide.dataset.state = STATE.SLIDINGBANNER.OPEN;
        this.getSlideByIndex(0).dataset.state = STATE.SLIDINGBANNER.CLOSED;
        return;

      default:
        this.getSlideByIndex(0).dataset.state = STATE.SLIDINGBANNER.CLOSED;
        this.getSlideByIndex(1).dataset.state = STATE.SLIDINGBANNER.CLOSED;
    }
  }

  initCarousel() {
    if (this.carousel) {
      // Clean up the swiper object for re-initialisation.
      this.carousel.destroy();
      this.swiperWrapper.classList.remove(classes.swiperWrapper);
      this.swiperSlide.forEach(slide =>
        slide.classList.remove(classes.swiperSlide)
      );
    }

    if (this.breakpoint.matches === false) {
      // Only add the wrapper class if the breakpoints initialise and we need to create the swiper.
      this.swiperWrapper.classList.add(classes.swiperWrapper);
      this.swiperSlide.forEach(slide =>
        slide.classList.add(classes.swiperSlide)
      );

      this.carousel = new Swiper(selectors.carouselWrapper, {
        modules: [Navigation, Pagination],
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 40,
        watchOverflow: true,
        hashNavigation: {
          watchState: true,
        },
        pagination: {
          el: classes.swiperPagination,
          clickable: true,
        },
      });
    }
  }

  registerEventListeners() {
    this.slides.forEach(slide => {
      slide.addEventListener('click', () => {
        this.setActiveSlide(slide);
      });
    });

    window.addEventListener('resize', () => {
      this.initCarousel();
    });
  }
}

customElements.define('sliding-banner-image', SlidingBannerImage);
